import type { KeyboardEvent, MouseEvent } from 'react';

// imported (not /public) so the bundler fingerprints them — and so the
// single-file demo build can inline them as data URIs
import logoColor from '@/assets/etc-logo-color.png';
import logoOnDark from '@/assets/etc-logo-on-dark.png';

export interface LogoProps {
  /** Nominal text size; the mark scales from it. */
  size?: number;
  light?: boolean;
  hideSubBrand?: boolean;
  onClick?: (e: MouseEvent | KeyboardEvent) => void;
}

/** Official ETC MCO mark + "Connect · Partner portal" product lockup. */
export function Logo({ size = 22, light = false, hideSubBrand = false, onClick }: LogoProps) {
  const logoH = size * 1.7;
  const src = light ? logoOnDark : logoColor;
  const clickable = typeof onClick === 'function';

  return (
    <div
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      aria-label={clickable ? 'ETC Connect — ir al panel principal' : undefined}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: size * 0.6,
        cursor: clickable ? 'pointer' : 'default',
        borderRadius: 8,
      }}
    >
      <img
        src={src}
        alt="ETC MCO · Educational Technology Consulting"
        style={{ height: logoH, width: 'auto', display: 'block' }}
      />
      {hideSubBrand ? null : (
        /* narrow screens drop the lockup so the topbar's right cluster fits */
        <div className="logo-sub" style={{ display: 'flex', alignItems: 'center', gap: size * 0.6 }}>
          <span
            aria-hidden="true"
            style={{
              width: 1,
              height: logoH * 0.7,
              background: light ? 'rgba(255,255,255,0.22)' : 'var(--line-2)',
              display: 'inline-block',
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
            <span
              style={{
                fontFamily: 'var(--display)',
                fontWeight: 800,
                fontSize: size * 0.92,
                letterSpacing: '-0.01em',
                color: light ? '#fff' : 'var(--brand-ink)',
              }}
            >
              Connect
            </span>
            <span
              style={{
                fontSize: size * 0.44,
                color: light ? 'rgba(255,255,255,0.7)' : 'var(--text-3)',
                fontWeight: 600,
                marginTop: 2,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
              }}
            >
              Partner portal
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
